import { InlineMessage, type InlineMessageTone } from '@crowdex/ui/components/feedback';
import { cn } from '@crowdex/ui/lib/utils';
import type { ReactNode } from 'react';

export type NoticeTone = InlineMessageTone;

/**
 * An {@link InlineMessage} placed in the conversation: aligned with its column,
 * or `compact` for narrow split panes and the floating composer.
 */
export function NoticeBanner({
  actions,
  children,
  className,
  compact = false,
  title,
  tone,
}: {
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
  compact?: boolean;
  title?: ReactNode;
  tone: NoticeTone;
}) {
  return (
    <div
      className={cn(
        'mx-auto w-full shrink-0',
        compact ? 'px-3 pt-2' : 'max-w-conversation px-4 pt-3',
        className,
      )}
    >
      <InlineMessage actions={actions} compact={compact} title={title} tone={tone}>
        {children}
      </InlineMessage>
    </div>
  );
}

/** A destructive {@link NoticeBanner}. */
export function ErrorBanner(props: Omit<Parameters<typeof NoticeBanner>[0], 'tone'>) {
  return <NoticeBanner tone="error" {...props} />;
}
